import { compose, withProps } from 'recompose';
import { InjectedFormProps, reduxForm, ConfigProps } from 'redux-form';
import { Routine, bindRoutineToReduxForm } from 'redux-saga-routines';
import * as dataLayer from 'shared/utils/gtmDataLayer';

export const form = <FormData = {}, Props = {}>(
  routine: Routine<any>,
  config: Partial<ConfigProps<FormData, Props, { message: string } | string>> = {}
) => {
  return compose(
    reduxForm({
      ...config,
      onSubmitFail(errors, ...args) {
        config.onSubmitFail && config.onSubmitFail(errors, ...args);
        if (!errors) {
          return;
        }
        (Object.keys(errors) as (keyof FormData)[]).forEach((field) => {
          dataLayer.push({
            eventCategory: 'form',
            eventAction: 'invalidate',
            eventLabel: `${config.form}.${field}`,
            //@ts-ignore
            eventValue: errors[field].message || errors[field],
          });
        });
      },
    }),
    // @ts-ignore
    withProps(({ handleSubmit }) => ({
      formSubmit: handleSubmit(bindRoutineToReduxForm(routine)),
    }))
  );
};

export interface FormProps<FormData = {}, Props = {}>
  extends Omit<InjectedFormProps<FormData, Props>, 'handleSubmit'> {
  formSubmit: () => void;
}
